import FormDatePicker from '../templates/FormDatePicker';
import { FormItemProps } from '../templates/FormProps';

const Birthday = ({
  name = 'birthdate',
  label = 'Birthday',
  placeholder = 'Enter Birthday',
  rules,
  required,
  disabled,
  ...props
}: FormItemProps): JSX.Element => {
  return (
    <FormDatePicker
      {...{ name, label, placeholder, required, disabled }}
      {...(rules && { rules })}
      {...props}
      notAccept="future"
    />
  );
};

export default Birthday;
